import { Paragraph } from 'docx';

// Utils
import { isEmptyValueArray, renderDateStringToMonthYear } from '@shared/utils';
import { formatDegreeAndFieldOfStudy } from '@/utils/textUtils';
import {
  bodyRun,
  buildIconPrefix,
  dividerParagraph,
  sidebarSectionTitle,
} from '../../utils';

// Types
import { TemplateProps } from '@/components/template/resume/type';

// Constants
import { COLORS, FONT_SIZES, SPACINGS } from '../../constants';

// Tokens
import { SECTION_TITLES } from '@/components/template/resume/Default/tokens';

/** Creates the sidebar education section */
export const EducationSection = (
  educations: TemplateProps['data']['educations'],
  locationIcon: Uint8Array | null,
): Paragraph[] => {
  if (!educations || isEmptyValueArray(educations)) return [];

  const paragraphs: Paragraph[] = [
    sidebarSectionTitle(SECTION_TITLES.education),
    dividerParagraph({ before: 0, after: 0 }),
  ];

  for (const education of educations) {
    const {
      degree = '',
      admission = '',
      graduation = '',
      school = '',
      address = '',
      major = '',
    } = education ?? {};

    const degreeField = formatDegreeAndFieldOfStudy(degree, major);
    const dateRange = renderDateStringToMonthYear(
      admission || '',
      graduation || '',
    );

    if (degreeField) {
      paragraphs.push(
        new Paragraph({
          spacing: { before: SPACINGS.medium },
          children: [bodyRun(degreeField, { bold: true })],
        }),
      );
    }

    if (dateRange) {
      paragraphs.push(
        new Paragraph({
          spacing: { before: SPACINGS.small },
          children: [
            bodyRun(dateRange, {
              size: FONT_SIZES.sm,
              color: COLORS.primary,
            }),
          ],
        }),
      );
    }

    if (school) {
      paragraphs.push(
        new Paragraph({
          spacing: { before: SPACINGS.small, after: SPACINGS.schoolAfter },
          children: [bodyRun(school, { size: FONT_SIZES.sm, bold: true })],
        }),
      );
    }

    if (address) {
      paragraphs.push(
        new Paragraph({
          spacing: { before: SPACINGS.medium },
          children: [...buildIconPrefix(locationIcon), bodyRun(address)],
        }),
      );
    }
  }

  return paragraphs;
};
